import { useState } from 'react'

const ContactPage = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [status, setStatus] = useState(null)
  const [sending, setSending] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!name || !email || !message) return

    setSending(true)
    setStatus(null)

    try {
      const res = await fetch('https://formsubmit.co/ajax/gm@greywolf.build', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name,
          email,
          message,
          _subject: `milligram.tv — Message from ${name}`
        })
      })

      if (res.ok) {
        setStatus('success')
        setName('')
        setEmail('')
        setMessage('')
      } else {
        setStatus('error')
      }
    } catch {
      setStatus('error')
    }
    setSending(false)
  }

  return (
    <div className="info-page">
      <div className="info-page__header">
        <h1 className="info-page__title">Contact</h1>
        <p className="info-page__subtitle">Get in touch with the milligram.tv team</p>
      </div>

      <div className="info-page__sections">
        <section className="info-page__section">
          <h3>Email</h3>
          <p>
            Reach us directly at{' '}
            <a href="mailto:gm@greywolf.build" className="contact-email">gm@greywolf.build</a>
          </p>
        </section>

        <section className="info-page__section">
          <h3>Send a Message</h3>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="contact-form__field">
              <label className="contact-form__label">Name</label>
              <input
                type="text"
                className="contact-form__input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your name"
                required
              />
            </div>
            <div className="contact-form__field">
              <label className="contact-form__label">Email</label>
              <input
                type="email"
                className="contact-form__input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
            </div>
            <div className="contact-form__field">
              <label className="contact-form__label">Message</label>
              <textarea
                className="contact-form__input contact-form__textarea"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="How can we help?"
                rows={5}
                required
              />
            </div>
            <button
              type="submit"
              className="vault-form__submit"
              disabled={sending || !name || !email || !message}
            >
              {sending ? 'Sending...' : 'Send Message'}
            </button>

            {status === 'success' && (
              <div className="swap-status swap-status--success">Message sent successfully!</div>
            )}
            {status === 'error' && (
              <div className="swap-status swap-status--error">Failed to send. Please email us directly.</div>
            )}
          </form>
        </section>

        <section className="info-page__section">
          <h3>Community</h3>
          <p>
            Join the conversation and stay up to date with the latest developments.
          </p>
          <div className="info-page__links">
            <a href="https://github.com/greywolf-build" target="_blank" rel="noreferrer" className="info-page__link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.166 6.839 9.489.5.092.682-.217.682-.482 0-.237-.009-.866-.013-1.7-2.782.604-3.369-1.34-3.369-1.34-.454-1.156-1.11-1.463-1.11-1.463-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.831.092-.646.35-1.086.636-1.337-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.578 9.578 0 0112 6.836a9.59 9.59 0 012.504.337c1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.138 20.163 22 16.418 22 12c0-5.523-4.477-10-10-10z" fill="currentColor"/>
              </svg>
              GitHub
            </a>
            <a href="https://x.com/greywolf_build" target="_blank" rel="noreferrer" className="info-page__link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" fill="currentColor"/>
              </svg>
              X (Twitter)
            </a>
          </div>
        </section>
      </div>
    </div>
  )
}

export default ContactPage
